module.exports = __webpack_public_path__ + "images/9ac914621fac68971bede4da7d10e10739e3bb12e7caddc2c2f0a6208bb57e22.svg";